import { render, staticRenderFns } from "./DocZN.vue?vue&type=template&id=53c4a71a&scoped=true&"
import script from "./DocZN.vue?vue&type=script&lang=js&"
export * from "./DocZN.vue?vue&type=script&lang=js&"
import style0 from "./DocZN.vue?vue&type=style&index=0&id=53c4a71a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c4a71a",
  null
  
)

export default component.exports